export const getMetafieldGraphQLQuery = (handle) => `{
  shop {
    discount_banner_message: metafield(namespace: "globals", key: "g_discount_banner_message") {
      value
    }
    discount_banner_text_colour: metafield(namespace: "globals", key: "g_discount_banner_text_colour") {
      value
    }
    discount_banner_colour: metafield(namespace: "globals", key: "g_discount_banner_colour") {
      value
    }
  }
  product(handle:"${handle}") {
    discount_banner_message: metafield(namespace: "discount_banner", key: "discount_message") {
      value
    }
    discount_banner_text_colour: metafield(namespace: "discount_banner", key: "discount_text_colour") {
      value
    }
    discount_banner_colour: metafield(namespace: "discount_banner", key: "discount_banner_colour") {
      value
    }
  }
}`;
